/**
 * An utility function to serialize axios params
 * By default, if we pass an array to axios params, it will be serialized as: `?key[]=value1&key[]=value2`
 * which requires special handling on the backend.
 * This function will serialize the params as: `?key=value1&key=value2`
 */
export function axiosParamsSerializer(obj: Record<string, unknown>) {
	/* eslint-disable no-param-reassign */
	return Object.entries(obj).reduce((acc, [key, value]) => {
		if (Array.isArray(value)) {
			value.forEach((item) => {
				acc += `${key}=${item}&`;
			});
		} else {
			acc += `${key}=${value}&`;
		}

		return acc;
	}, '').slice(0, -1);
	/* eslint-enable no-param-reassign */
}
